import { render, staticRenderFns } from "./NDCFareOption.vue?vue&type=template&id=065ebba8&scoped=true&"
import script from "./NDCFareOption.vue?vue&type=script&lang=js&"
export * from "./NDCFareOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065ebba8",
  null
  
)

export default component.exports